export default __webpack_public_path__ + "static/media/knoor.d00150f7.svg";